import React from "react";
import "./Button.scss";

export default function Button({text, className, href, newTab, onClick}) {
  if (onClick) {
    return (
      <div className={className}>
        <button type="button" className="main-button" onClick={onClick}>
          {text}
        </button>
      </div>
    );
  }
  return (
    <div className={className}>
      <a className="main-button" href={href} target={newTab && "_blank"}>
        {text}
      </a>
    </div>
  );
}
